import Vue from 'vue'
// export const eventBus = new Vue()
export default new Vue()



// WEBPACK FOOTER //
// ./src/utils/eventBus.js